import CookieAnalyticsManager from '../../CookieBannerManager/CookieAnalyticsManager';

export default () => {
  const analyticsManager = new CookieAnalyticsManager();

  return !!analyticsManager.getInitialValue();
};
